export default __webpack_public_path__ + "static/media/ic-no-internet.9d7f203b.svg";